import firebase from 'firebase/app';

import 'firebase/messaging';
import config from './config';

const firebaseConfig = config?.FIREBASE_CONFIG || {
    apiKey: "AIzaSyCdo8Fc5y97oQ3FN7VIWk0-SlHQKMnjuXk",
    authDomain: "tna-fcm.firebaseapp.com",
    projectId: "tna-fcm",
    storageBucket: "tna-fcm.firebasestorage.app",
    messagingSenderId: "96167652953",
    appId: "1:96167652953:web:af882701ea1762b3278b48",
    measurementId: "G-M3B66LTEPW"
};



export default firebase.initializeApp(firebaseConfig);